import memoize from 'lodash/memoize'

export const Chains = {
  Mainnet: 1,
  Ropsten: 3,
  Rinkeby: 4,
  Goerli: 5,
  Kovan: 42,
  Polygon: 137,
  Matic: 138,
} as const
// intentionally
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Chains = typeof Chains[keyof typeof Chains]

export const ChainNames: Record<Chains, string | undefined> = {
  [Chains.Mainnet]: 'Mainnet',
  [Chains.Ropsten]: 'Ropsten',
  [Chains.Rinkeby]: 'Rinkeby',
  [Chains.Goerli]: 'Goerli',
  [Chains.Kovan]: 'Kovan',
  [Chains.Matic]: 'Matic',
  [Chains.Polygon]: 'Polygon',
} as const

export const parseChainId = memoize((chainId: number | string) => {
  return Number(chainId) as Chains
})

export const getChainName = (chainId: number) =>
  ChainNames[parseChainId(chainId)] || 'Unknown'

export const ChainColors: Record<Chains, string | undefined> = {
  [Chains.Mainnet]: '#29b6af',
  [Chains.Ropsten]: '#ff4a8d',
  [Chains.Rinkeby]: '#f6c343',
  [Chains.Goerli]: '#3099f2',
  [Chains.Kovan]: '#9064ff',
  [Chains.Matic]: '#ff4a8d',
  [Chains.Polygon]: '#8247e5',
} as const

export const getChainColor = (chainId: number) =>
  ChainColors[parseChainId(chainId)] || 'rgba(193, 217, 254, 0.36)'

export const ADD_CHAIN_PARAMS = {
  [Chains.Polygon]: {
    chainName: 'Polygon Mainnet',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    rpcUrls: ['https://polygon-rpc.com'],
    blockExplorerUrls: ['https://polygonscan.com/'],
    iconUrls: [''],
  },
}
